import { PageHeaderContext } from "./page-header.context";
import type { PageHeaderProps } from "./types-page-header";
import { usePageHeader } from "./use-page-header";
import { PageHeaderView } from "./view-page-header";

export function PageHeaderRoot({ children, ...options }: PageHeaderProps) {
  const viewModel = usePageHeader(options);

  return (
    <PageHeaderContext.Provider value={viewModel}>
      <PageHeaderView
        printHide={viewModel.printHide}
        variant={viewModel.variant}
        testId={viewModel.testId}
        className={viewModel.className}
        style={viewModel.style}
        rest={viewModel.rest}
      >
        {children}
      </PageHeaderView>
    </PageHeaderContext.Provider>
  );
}
PageHeaderRoot.displayName = "PageHeader.Root";
